import AppRoutes from "./routes/routes";

const App = () => <AppRoutes />;

export default App;
